"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ shape, palette, spacing }, { account }) => ({
    rootContainer: {
        borderRadius: shape.borderRadius * 2,
        border: (account === null || account === void 0 ? void 0 : account.isClosed) ? `1px solid ${palette.text.secondary}` : 'none',
        margin: `${spacing(1)} 0px`,
        paddingLeft: spacing(2),
        paddingRight: spacing(3),
    },
    listItemText: {
        paddingLeft: 0,
    },
    dialogContent: {
        minWidth: 500,
        display: 'flex',
    },
    primaryItem: {
        display: 'flex',
    },
    statusContainer: {
        borderRadius: shape.borderRadius,
        flex: '0 0 auto',
        margin: 'auto 5px',
        height: 'inherit',
    },
    statusRoot: {
        borderRadius: shape.borderRadius,
        marginTop: 1,
        boxSizing: 'border-box',
        padding: `${spacing(0.25)} ${spacing(1)}`,
        color: palette.text.primary,
    },
    statusClose: {
        backgroundColor: palette.action.disabled,
    },
    statusError: {
        backgroundColor: palette.status.surfaceStrong,
    },
    ignoredAccountIcon: {
        marginLeft: 10,
    },
    ofxShadowAccountInfoButton: {
        marginLeft: 4,
        padding: 2,
    },
    ofxShadowAccountInfoIcon: {
        fontSize: '1.2rem',
        color: palette.icon.tertiary,
    },
    txnsTransfersStatusContainer: {
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    greenCheck: {
        color: palette.success.dark,
    },
});
exports.default = styles;
